import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelector } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.Colonia;
export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void> | void;
    onGuardar: () => Promise<void>;
    nuevo: boolean;
}

export function validar(x: Entity) {
    const rules: validation.Rules<Entity> = {
        Nombre: validation.required,
        ClaveSat: validation.required
    };
    return validation.getErrors(rules, x);
}

/**
* Componente para editar un Entity
*/
export class ColoniaFormNoRx extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    errors = createSelector(this.value, x => validar(x));
    hasError = createSelector(this.errors, x => validation.hasError(x));
    getField = formfields(() => this.props, () => this.errors(this.props));

    render() {
        const { value, onGuardar, nuevo } = this.props;
        const getField = this.getField;

        const hasError = this.hasError(this.props);
        const Text = getField(kea.Text);

        const TipoColoniaSelector = getField(selectores.TipoColonia);

        const EstadoSelector = getField(selectores.Estado);
        const IdEstado = this.props.value.IdEstado === undefined || this.props.value.IdEstado == null? 0 : this.props.value.IdEstado

        const MunicipioSelector = getField(selectores.MunicipioFiltroEstado( IdEstado ));
        const IdMunicipio = this.props.value.IdMunicipio === undefined || this.props.value.IdMunicipio == null? 0 : this.props.value.IdMunicipio

        const CiudadSelector = getField(selectores.CiudadFiltroMunicipio( IdMunicipio ));


        return (
            <div>
                <kea.Title titulo="Colonia" onRegresar={() => history.go("../")} />
                {kea.autogrid(4, [
                    <Text field="Nombre" label="Nombre" />,
                    <Text field="CodigoPostal" label="Codigo Postal" />,
                    <Text field="ClaveSat" label="ClaveSat" />,


                    <EstadoSelector field="IdEstado" label="Estado" />,
                    <MunicipioSelector field="IdMunicipio" label="Municipio" />,
                    <CiudadSelector field="IdCiudad" label="Ciudad" />,

                    <TipoColoniaSelector field="IdTipoColonia" label="Tipo colonia" />
                ])}

                <div className="row">
                    <div className="col-md-12">
                        <kea.GuardarButton onClick={onGuardar} disabled={hasError} />
                    </div>
                </div>
            </div>);
    }
}

export const ColoniaForm = componentToRx(ColoniaFormNoRx);


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/DireccionColonia/edit/form.tsx